import { fillBasket, initEvents } from './checkoutShared';
import { CheckoutService } from './checkoutService';
const checkoutService = new CheckoutService();
import { onloadTracking } from './Tracking/checkoutTrackingStep1';
import { factfinderBasketTracking } from '../FactFinder/Tracking/factFinderTracking';
import ICheckoutflowResponse = CheckoutflowReponse.ICheckoutflowResponse;
import ICart = CheckoutflowReponse.ICart;
import { dangerAlert } from '../Shared/AlertHelper';
import { initModalImageZoom } from '../Shared/modalImageZoom';

let initialCustomerMessageValue: string = '';
let initialOrderCodeValue: string = '';

$(() => {
    initBasket();
    initModalImageZoom();

    if ($('#ApiError').val()) {
        dangerAlert($('#ApiError').val());
    }
});

$('#checkoutDiscountButton').on('click', function() {
    var code = $('#discountInputSearch').val();
    if (code) {
        checkoutService
            .addDiscountToCart(code as string)
            .then(data => {
                if (data == false) {
                    initBasket();
                    $('#discountInputSearch').val('');
                    $('#discountContainer .coupon-code').addClass('hide');
                    $('#discountContainer .coupon-code-result').removeClass('hide');
                }
            })
            .catch(() => {});
    }
});
$('#checkoutIsbnSearchButton').on('click', function() {
    addProductByIsbn(
        $(this)
            .next('.inputEls')
            .find('#checkoutIsbnSearch')
    );
});

$('#checkoutIsbnSearch').on('keyup', function(e) {
    if (e.keyCode == 13) {
        addProductByIsbn($(this));
    }
});

$('.addAdditionalCartInfo').on('click', function() {
    const orderCode = $('.additionalCartInfoOrderCode').val() as string;
    const customerMessage = $('.additionalCartInfoCustomerMessage').val() as string;
    const redirectLink = $(this).attr('data-redirectlink') as string;
    if (orderCode != initialOrderCodeValue || customerMessage != initialCustomerMessageValue) {
        checkoutService
            .addAdditionalInfoToCart(orderCode, customerMessage)
            .then(() => {
                window.location.href = redirectLink;
            })
            .catch(() => {});
    } else {
        window.location.href = redirectLink;
    }
});

/**
 * Initialer Request beim Warenkorb-Aufruf.
 */
function initBasket() {
    checkoutService
        .showBasket()
        .then(async (response: ICheckoutflowResponse) => {
            let cart = response.cart;
            fillBasket(cart);
            fillAdditionalInfo(cart);
            showShippingNotification(response);
            initEvents();
            onloadTracking(cart);
            localStorage.setItem('currentCart', JSON.stringify(response.cart));
            factfinderBasketTracking(cart.lineItems);
        })
        .catch(() => {
            $('.hideInEmptyBasket').addClass('hide');
            $('.showInEmptyBasket').removeClass('hide');
            $('.disableInEmptyBasket').addClass('disabled-Element');
        });
}

/**
 * Ruft "addItemByIsbnSearch" mit dem value aus dem übergebenen Inputfield auf.
 * @param input
 */
function addProductByIsbn(input: JQuery) {
    if (input) {
        let isbn = input.val() as string;
        if (isbn) {
            checkoutService
                .addItemByIsbnSearch(isbn)
                .then((cart: ICart) => {
                    fillBasket(cart);
                })
                .catch(() => {});
        }
    }
}

function fillAdditionalInfo(cart: ICart) {
    if (
        cart &&
        cart.additionalCartInfo &&
        (cart.additionalCartInfo.OrderCode || cart.additionalCartInfo.CustomerMessage)
    ) {
        initialCustomerMessageValue = cart.additionalCartInfo.CustomerMessage;
        initialOrderCodeValue = cart.additionalCartInfo.OrderCode;

        $('.additionalCartInfoOrderCode').val(initialOrderCodeValue);
        $('.additionalCartInfoCustomerMessage').val(initialCustomerMessageValue);

        $('.additional-data-box .data-trigger').trigger('click');
    }
}

/**
 * Je nachdem, ob in der Cart das Flag zum Verstecken des Lieferkostsenhinweises gesetzt ist,
 * wird dieser asugeblendet
 * @param response
 */
function showShippingNotification(response: ICheckoutflowResponse) {
    if (response.shippingCostInfo && response.shippingCostInfo.hideNoShippingCostHintAtCart) {
        $('#basket-shipping-taxCost').addClass('hide');
        $('.total-shipping-notification-container').html('');
        $('#basket-shipping-taxCost_with_hyperLink').removeClass('hide');
    } else {
        $('#basket-shipping-taxCost_with_hyperLink').addClass('hide');
        $('#basket-shipping-taxCost').removeClass('hide');
    }
}
